import { render, staticRenderFns } from "./WqMessageRevPersonList.vue?vue&type=template&id=003270a7&scoped=true"
import script from "./WqMessageRevPersonList.vue?vue&type=script&lang=js"
export * from "./WqMessageRevPersonList.vue?vue&type=script&lang=js"
import style0 from "./WqMessageRevPersonList.vue?vue&type=style&index=0&id=003270a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003270a7",
  null
  
)

export default component.exports